import { render, staticRenderFns } from "./productionConfig.vue?vue&type=template&id=0eedce40&scoped=true"
import script from "./productionConfig.vue?vue&type=script&lang=js"
export * from "./productionConfig.vue?vue&type=script&lang=js"
import style0 from "./productionConfig.vue?vue&type=style&index=0&id=0eedce40&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eedce40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eedce40')) {
      api.createRecord('0eedce40', component.options)
    } else {
      api.reload('0eedce40', component.options)
    }
    module.hot.accept("./productionConfig.vue?vue&type=template&id=0eedce40&scoped=true", function () {
      api.rerender('0eedce40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/productionConfig.vue"
export default component.exports